{
  "dashboard": {
    "welcomeBack": "おかえりなさい",
    "subtitle": "あなたのライブオークション管理センター。入札、ウォッチリスト、支払いを一か所で管理できます。",
    "sellerDashboardBtn": "販売者ダッシュボード",
    "listCardBtn": "カードを出品",
    "stat": {
      "leadingLabel": "現在リード中",
      "leadingHint": "現在勝っているライブオークション",
      "outbidLabel": "入札更新",
      "outbidHint": "再入札が必要なライブオークション",
      "wonLabel": "落札済み",
      "wonHint": "完了した落札",
      "watchlistLabel": "ウォッチリスト",
      "watchlistHint": "追跡中のカード"
    },
    "summary": {
      "pendingPaymentsLabel": "支払い待ち",
      "pendingPaymentsHint": "決済待ちの注文",
      "totalSpendLabel": "合計支出",
      "totalSpendHint": "支払い済み注文の合計",
      "ordersLabel": "注文",
      "ordersHint": "全期間の注文履歴",
      "listingsLabel": "自分の出品",
      "listingsHint": "出品しているカード"
    },
    "pendingBanner": "{count, plural, other {支払い待ちの注文が # 件あります。}}",
    "completePayment": "支払いを完了する",
    "leadingListTitle": "リード中のオークション",
    "leadingListEmpty": "現在、最高入札者になっているライブオークションはありません。",
    "outbidListTitle": "入札更新が必要です",
    "outbidListEmpty": "入札更新はありません——順調です。",
    "watchlistListTitle": "ウォッチリスト",
    "watchlistListEmpty": "ウォッチリストは空です。",
    "viewAll": "すべて見る",
    "quickLink": {
      "sellerTitle": "販売者ダッシュボード",
      "sellerHint": "売上、収益、支払い、パフォーマンス",
      "myBidsTitle": "自分の入札",
      "myBidsHint": "活動状況を確認",
      "watchlistTitle": "ウォッチリスト",
      "watchlistHint": "追跡中のカード"
    }
  },
  "sidebar": {
    "buyingGroup": "購入",
    "dashboard": "ダッシュボード",
    "browseAuctions": "オークションを探す",
    "watchlist": "ウォッチリスト",
    "myBids": "自分の入札",
    "wonOrders": "落札・注文",
    "sellingGroup": "販売",
    "sellerDashboard": "販売者ダッシュボード",
    "myAuctions": "自分のオークション",
    "listCard": "カードを出品",
    "payouts": "支払い",
    "accountGroup": "アカウント",
    "notifications": "お知らせ",
    "settings": "設定",
    "adminGroup": "管理",
    "admin": "管理",
    "signOut": "ログアウト"
  },
  "billing": {
    "eyebrow": "販売者",
    "title": "手数料と支払い",
    "subtitle": "BidNova は成約時のみシンプルな8%の手数料を請求します。月額料金、サブスクリプション料金、出品料はありません。",
    "included": {
      "noListingFees": "出品料なし",
      "noMonthlyFees": "月額料金なし",
      "noSubscriptionFees": "サブスクリプション料金なし",
      "commissionOnly": "成約時のみ手数料が発生",
      "securePayouts": "Stripeによる安全な英ポンド支払い",
      "buyerProtection": "購入者保護と紛争対応込み"
    },
    "commissionTitle": "販売者手数料",
    "commissionBadge": "一律8%",
    "commissionDesc": "商品が売れたときのみ請求されます。",
    "howTitle": "支払い計算方法",
    "howDesc": "すべての注文で明細が透明に表示されます。",
    "formula": "販売者支払額 = 最終落札価格 − 8% BidNova 手数料",
    "bullet1": "購入者は最終落札額に加え、設定された送料を支払います。",
    "bullet2": "BidNova は商品代金(送料を除く)から8%の手数料を差し引きます。",
    "bullet3": "配送確認および紛争対応期間終了後、残額が接続済みのStripeアカウントに支払われます。",
    "bullet4": "Stripe決済処理手数料が適用される場合があり、各注文に表示されます。",
    "exampleTitle": "例",
    "exampleFinalPrice": "最終落札価格",
    "exampleCommission": "BidNova 手数料 (8%)",
    "examplePayout": "販売者支払額"
  },
  "scanHistory": {
    "eyebrow": "AIスキャナー",
    "title": "スキャン履歴",
    "subtitle": "これまでに実行したすべてのスキャンと、認識されたカード、信頼度、状態の提案、真贋に関する注記です。",
    "newListing": "新規出品",
    "loading": "読み込み中…",
    "empty": "まだスキャン履歴がありません。出品を開始してAIで最初のカードをスキャンしましょう。",
    "conditionFallback": "状態 —",
    "verifyBadge": "要確認",
    "confirmedBadge": "確認済み",
    "deleteConfirm": "このスキャンを削除しますか?この操作は取り消せません。",
    "deleteSuccess": "スキャンを削除しました",
    "duplicateBtn": "複製"
  },
  "shipping": {
    "backToSeller": "販売者ダッシュボードに戻る",
    "eyebrow": "配送",
    "title": "配送設定",
    "subtitle": "BidNova出品時の配送オプションを管理します。BidNovaで販売するために Royal Mail を接続する必要はありません。",
    "loading": "配送設定を読み込み中…",
    "prefsHeading": "配送設定",
    "prefsDesc": "新規出品作成時に使用するデフォルトの荷物とサービスを設定します。",
    "noteOptional": "Royal Mail Click & Drop は任意です。出品時にサポートされている任意の配送サービスを選択できます。",
    "preferredService": "希望する配送サービス",
    "preferredServiceHelp": "新規出品のデフォルトとして使用されます。出品ごとに変更できます。",
    "defaultWeight": "デフォルトの荷物重量(グラム)",
    "defaultFormat": "デフォルトの梱包タイプ",
    "futureHeading": "今後追加予定の設定",
    "futureDispatch": "発送時間(販売後どれくらいで発送するか)",
    "futureDomestic": "国内配送の希望設定",
    "futureCollection": "集荷の希望設定",
    "futureNote": "これらのオプションはまだ利用できません。現時点では各出品の説明で発送予定をお知らせください。",
    "senderHeading": "差出人 / 返送先情報",
    "senderDesc": "該当する場合、配送ラベルや返送先住所に使用されます。",
    "senderName": "屋号 / 差出人名",
    "senderEmail": "連絡先メールアドレス",
    "senderPhone": "連絡先電話番号",
    "senderLine1": "住所1行目",
    "senderLine2": "住所2行目",
    "senderCity": "市区町村",
    "senderCounty": "州/郡",
    "senderPostcode": "郵便番号",
    "senderCountry": "国",
    "savePreferences": "設定を保存",
    "saveSuccess": "配送設定を保存しました",
    "saveError": "配送設定を保存できませんでした。もう一度お試しください。",
    "advancedHeading": "高度な配送連携",
    "advancedDesc": "任意機能。ラベル生成を統合するため、サードパーティの配送アカウントを接続します。",
    "royalMailTitle": "Royal Mail Click & Drop",
    "royalMailDesc": "Royal Mail Click & Drop アカウントを接続すると、BidNoveから直接配送ラベルを生成できます。配送ラベル料金はお客様のRoyal Mailアカウントに直接請求されます。BidNovaはRoyal Mailの送料を請求・保存しません。",
    "royalMailOptionalNote": "この連携は任意で、既にRoyal Mail Click & Dropを利用している出品者向けです。",
    "statusConnected": "接続済み",
    "statusUnsuccessful": "接続失敗",
    "statusNotConnected": "未接続",
    "connectedMessage": "Royal Mail Click & Drop アカウントが接続されています。",
    "onFile": "登録済み",
    "lastChecked": "最終確認",
    "testConnection": "接続テスト",
    "disconnect": "接続解除",
    "connectSuccess": "Royal Mail Click & Drop に接続しました",
    "connectErrorTitle": "接続失敗",
    "connectErrorDesc": "Royal Mail Click & Drop アカウントを確認できませんでした。APIキーを確認して再度お試しください。",
    "testSuccess": "Royal Mail の接続は有効です",
    "disconnectSuccess": "Royal Mail の接続を解除しました",
    "disconnectError": "Royal Mail の接続を解除できませんでした。もう一度お試しください。",
    "invalidTitle": "接続失敗",
    "invalidDesc": "Royal Mail Click & Drop アカウントを確認できませんでした。APIキーを確認して再度お試しください。",
    "notConnectedNote": "Royal Mailを接続しなくてもBidNovaで販売できます。統合ラベル生成が必要な場合のみClick & Dropを接続してください。",
    "apiKeyLabel": "Royal Mail Click & Drop APIキー",
    "apiKeyHelp": "APIキーは暗号化して保存され、保存後は全体が表示されることはありません。",
    "connectVerify": "接続して確認",
    "connecting": "接続中…",
    "disconnectDialogTitle": "Royal Mail の接続を解除しますか?",
    "disconnectDialogDesc": "接続を解除すると、BidNovaはRoyal Mailラベルを作成できなくなります。既存のラベルや過去の注文には影響しません。",
    "cancel": "キャンセル"
  },
  "shipped": {
    "eyebrow": "販売者",
    "title": "発送履歴",
    "subtitle": "過去の発送、配送結果、返品を確認できます。閲覧のみ。",
    "backToDashboard": "ダッシュボードに戻る",
    "tabShipped": "発送済み注文",
    "tabDelivered": "配達完了",
    "tabCancelled": "キャンセル済み",
    "tabReturned": "返品済み",
    "searchPlaceholder": "購入者、オークションタイトル、追跡番号で検索…",
    "searchAriaLabel": "発送済み注文を検索",
    "filterBuyer": "購入者",
    "filterBuyerPlaceholder": "購入者名",
    "filterTracking": "追跡番号",
    "filterTrackingPlaceholder": "Royal Mail 追跡番号",
    "filterAuction": "オークション",
    "filterAuctionPlaceholder": "オークションタイトル",
    "filterFrom": "開始",
    "filterTo": "終了",
    "resultsCount": "{count, plural, other {# 件の結果}}",
    "clearFilters": "フィルターをクリア",
    "refresh": "更新",
    "colOrder": "注文",
    "colAuction": "オークション",
    "colBuyer": "購入者",
    "colTracking": "追跡番号",
    "colService": "サービス",
    "colRoyalMail": "Royal Mail",
    "colDispatched": "発送済み",
    "colDelivered": "配達完了",
    "colTotal": "合計",
    "colStatus": "ステータス",
    "colActions": "操作",
    "loadError": "発送履歴を読み込めませんでした。",
    "retry": "再試行",
    "noMatches": "該当する注文はありません。",
    "pageOf": "{totalPages} ページ中 {page} ページ目",
    "previous": "前へ",
    "next": "次へ",
    "viewOrder": "注文を見る",
    "copyTracking": "追跡番号をコピー",
    "copyTrackingSuccess": "追跡番号をコピーしました。",
    "copyTrackingError": "追跡番号をコピーできませんでした。",
    "downloadLabel": "配送ラベルをダウンロード",
    "labelUnavailable": "ラベルは利用できません。",
    "trackAria": "Royal Mail で {tracking} を追跡",
    "statusLabelCreated": "ラベル作成済み",
    "statusDispatched": "発送済み",
    "statusInTransit": "配送中",
    "statusDelivered": "配達完了",
    "statusDeliveryAttempted": "配達試行済み",
    "statusCancelled": "キャンセル済み",
    "statusReturned": "返品済み",
    "orderStatusShipped": "発送済み",
    "orderStatusDelivered": "配達完了",
    "orderStatusReleased": "完了",
    "orderStatusCancelled": "キャンセル済み",
    "orderStatusRefunded": "返金済み"
  },
  "sellerIndex": {
    "eyebrow": "販売者",
    "title": "ダッシュボード",
    "subtitle": "出品、販売、支払い、パフォーマンスを一か所で管理します。",
    "shippedHistoryBtn": "発送履歴",
    "shippingSettingsBtn": "配送設定",
    "tabOverview": "概要",
    "tabStripe": "Stripe",
    "tabAuctions": "オークション",
    "tabFulfilment": "配送処理",
    "tabSales": "販売",
    "tabEarnings": "収益",
    "tabPerformance": "パフォーマンス",
    "tabAnalytics": "分析",
    "tabPortfolio": "ポートフォリオ",
    "tabNotifications": "お知らせ",
    "kpi": {
      "totalSales": "総売上",
      "totalSalesHint": "支払い済み + 発送済み + 配達完了 + 支払い完了",
      "auctionRevenue": "オークション収益",
      "auctionRevenueHint": "オークション落札による売上",
      "binRevenue": "即決価格収益",
      "binRevenueHint": "{count, plural, other {即決注文 # 件}}",
      "binConversionRate": "即決価格コンバージョン率",
      "binConversionHint": "{listings} 件中 {sold} 件成約",
      "binAvgPrice": "即決価格平均",
      "binAvgPriceHint": "即決価格の平均販売価格",
      "activeBinListings": "進行中の即決価格出品",
      "activeBinListingsHint": "現在即決価格で購入可能",
      "expiredBinListings": "期限切れの即決価格出品",
      "expiredBinListingsHint": "即決価格が有効だが終了または売却済み",
      "reservationsExpired": "予約期限切れ",
      "reservationsExpiredHint": "即決価格の決済が放棄された件数",
      "netEarnings": "純収益",
      "netEarningsHint": "プラットフォーム手数料8%控除後",
      "heldBalance": "保留残高",
      "heldBalanceHint": "配送確認待ち",
      "availablePayout": "支払い可能額",
      "availablePayoutHint": "Stripeアカウントに支払い済み",
      "platformFees": "プラットフォーム手数料",
      "activeAuctions": "進行中のオークション",
      "totalWatchers": "総ウォッチ数",
      "totalWatchersHint": "進行中のオークション全体の合計",
      "endingSoon": "24時間以内に終了",
      "pendingApproval": "承認待ち",
      "pendingApprovalHint": "モデレーターの審査待ち",
      "rejected": "却下",
      "awaitingShipment": "発送待ち",
      "awaitingShipmentHint": "発送準備完了",
      "completedOrders": "完了した注文"
    },
    "refresh": "更新",
    "monthlySales": "月間売上",
    "monthlySalesEmpty": "まだ販売がありません——最初の注文がここに表示されます。",
    "salesTooltipLabel": "売上",
    "recentActivity": "最近のアクティビティ",
    "recentActivityEmpty": "まだアクティビティはありません。",
    "stripeAccountTitle": "Stripe Express アカウント",
    "connectedAccount": "接続済みアカウント",
    "openExpressDashboard": "Stripe Express ダッシュボードを開く",
    "finishOnboarding": "Stripeのオンボーディングを完了して、Expressダッシュボードを開き支払いを受け取りましょう。",
    "yourAuctions": "自分のオークション",
    "yourAuctionsDesc": "出品を管理し、入札のないフィールドを編集、終了した商品のキャンセルや再出品を行います。",
    "openAuctionsManager": "オークション管理を開く",
    "listNewCard": "新しいカードを出品",
    "filteredByStatus": "ステータスで絞り込み中:",
    "clearFilter": "フィルターをクリア",
    "bidLockNote": "オークションに入札が入ると、編集できるのは説明と写真のみです——価格と終了時間はロックされます。",
    "colAuction": "オークション",
    "colStatus": "ステータス",
    "colEnds": "終了",
    "colBids": "入札数",
    "colWatchers": "ウォッチ数",
    "colHighestBid": "最高入札額",
    "colListed": "出品日",
    "sortByAria": "{label}で並び替え",
    "loading": "読み込み中…",
    "noListings": "まだ出品がありません。",
    "ended": "終了",
    "salesShipping": "販売と配送",
    "salesShippingDesc": "注文の全工程:支払い済み → 準備中 → Click & Drop へエクスポート済み → 発送済み → 配達完了 → 支払い完了。一括CSVエクスポート、追跡番号付きの発送済みマーク、Royal Mailリンクはすべて注文ワークスペースにあります。",
    "openOrdersWorkspace": "注文ワークスペースを開く",
    "salesPipeline": "販売プロセス",
    "salesPipelineDesc": "各段階をクリックすると、注文ワークスペースで該当する注文を表示できます。",
    "stageAwaitingPayment": "支払い待ち",
    "stagePaid": "支払い済み",
    "stageReadyToShip": "発送準備完了",
    "stageShipped": "発送済み",
    "stageDelivered": "配達完了",
    "stageReleased": "支払い完了",
    "tileGrossSales": "総売上",
    "tilePlatformFees": "プラットフォーム手数料",
    "tileShippingReceived": "受領した送料",
    "tileRefunds": "返金",
    "tileNetEarnings": "純収益",
    "tileHeldBalance": "保留残高",
    "tileReleasedPayout": "支払い済み",
    "tileActiveDisputes": "進行中の紛争",
    "nextExpectedPayout": "次回予定の支払い",
    "ordersPendingRelease": "{count, plural, other {支払い待ちの注文 # 件}}",
    "showingPendingHint": "支払い待ちを表示中——クリックで支払い済みを表示",
    "clickToViewIncluded": "クリックして含まれる注文を表示",
    "pendingPayoutsTitle": "支払い待ち",
    "payoutHistoryTitle": "支払い履歴",
    "downloadCsv": "CSV明細をダウンロード",
    "noPendingPayouts": "支払い待ちはありません。",
    "noReleasedPayouts": "まだ支払いはありません。",
    "colOrderDate": "注文日",
    "colDate": "日付",
    "colAmount": "金額",
    "colReference": "参照番号",
    "csvOrder": "注文",
    "csvAuction": "オークション",
    "csvDate": "日付",
    "csvStatus": "ステータス",
    "csvGross": "総額",
    "csvFee": "手数料",
    "csvShipping": "送料",
    "csvNet": "純額",
    "csvReleased": "支払い済み",
    "csvReference": "参照番号",
    "sellerStatus": "販売者ステータス",
    "perfCompletedSales": "完了した販売",
    "perfCancellationRate": "キャンセル率",
    "perfLateShipments": "発送遅延 (>72時間)",
    "perfAvgDispatch": "平均発送時間",
    "perfDeliveryConfirmed": "配送確認済み",
    "perfOpenDisputes": "進行中の紛争",
    "perfAccountWarnings": "アカウント警告",
    "feedbackNote": "評価スコア——購入者評価機能は近日公開予定です。上記の発送速度と配送確認率がすでにあなたの販売者評価に反映されています。",
    "sellerNotifications": "販売者へのお知らせ",
    "markAllRead": "すべて既読にする",
    "allCaughtUp": "すべて確認済みです。",
    "somethingWrong": "エラーが発生しました",
    "retry": "再試行"
  },
  "profile": {
    "eyebrow": "アカウント",
    "title": "アカウントとプロフィール",
    "subtitle": "ログイン用メールアドレスは非公開であり、公開販売者プロフィールに表示されることはありません。",
    "privateHeading": "非公開のアカウント情報",
    "privateDesc": "本人のみに表示され、公開ページには表示されません。",
    "loginEmail": "ログイン用メールアドレス",
    "emailVerified": "メール認証済み",
    "verifiedYes": "はい",
    "verifiedNo": "未認証",
    "changePassword": "パスワードを変更",
    "publicHeading": "公開プロフィール",
    "avatarLabel": "アバターまたはショップロゴ",
    "avatarHelp": "JPG、PNG、WebP・最大5MB。",
    "uploading": "アップロード中…",
    "uploadImage": "画像をアップロード",
    "remove": "削除",
    "displayName": "表示名",
    "displayNameHelp": "あなたの公開個人名またはコミュニティ名。",
    "username": "ユーザー名",
    "usernameHelp": "3〜30文字、小文字、数字、ハイフンが使用できます。公開URLに使用されます:",
    "usernameChangeNote": "ユーザー名は30日ごとに1回変更できます。",
    "checkingAvailability": "利用可能か確認中…",
    "usernameCurrent": "現在使用中のユーザー名です。",
    "usernameAvailable": "このユーザー名は使用可能です。",
    "shopName": "ショップ名",
    "shopNamePlaceholder": "任意 — 例: Double Blessings TCG",
    "shopNameHelp": "設定すると、表示名の代わりに購入者に表示されます。",
    "bio": "自己紹介",
    "bioPlaceholder": "簡単な自己紹介文。プレーンテキストのみ。",
    "location": "公開する所在地",
    "locationPlaceholder": "例: Manchester, United Kingdom",
    "locationHelp": "自宅の詳細な住所は入力しないでください。この情報は公開される場合があります。",
    "coverImage": "カバー画像",
    "coverImageHelp": "公開販売者ページ上部に表示される横長バナー。JPG、PNG、WebP・最大5MB。",
    "noCoverImage": "カバー画像はまだありません",
    "uploadCover": "カバーをアップロード",
    "replaceCover": "カバーを変更",
    "website": "ウェブサイト",
    "socialTwitter": "Twitter / X",
    "socialInstagram": "Instagram",
    "socialFacebook": "Facebook",
    "socialYoutube": "YouTube",
    "socialTiktok": "TikTok",
    "socialDiscord": "Discord",
    "publicSellerProfile": "公開販売者プロフィール",
    "publicSellerProfileDesc": "オンにすると、購入者は次のURLであなたの販売者ページを訪問できます:",
    "publicPreview": "公開プレビュー",
    "saving": "保存中…",
    "saveProfile": "プロフィールを保存",
    "toastProfileUpdated": "公開プロフィールを更新しました。",
    "toastSaveFailed": "プロフィールを保存できませんでした。",
    "toastInvalidImage": "JPG、PNG、またはWebP形式の画像を選択してください。",
    "toastImageTooLarge": "画像は5MB以下にしてください。",
    "toastCoverReady": "カバー画像の準備ができました。プロフィールを保存して公開してください。",
    "toastUploadFailed": "アップロードに失敗しました。",
    "toastAvatarReady": "アバターの準備ができました。プロフィールを保存して公開してください。"
  }
}
